import { useNavigate } from "react-router-dom";

export default function ProfileCard({ user, level, leaderboardData }) {
  const navigate = useNavigate();
  const progressDeg = (level?.progress_percentage / 100) * 360;

  return (
    <div
      className="p-4 flex-grow-1 d-flex flex-column"
      style={{
        border: "1px solid #2A4051",
        backgroundColor: "#1C2A37",
        borderRadius: "12px",
      }}
    >
      <div className="d-flex flex-column align-items-center text-center justify-content-center flex-grow-1">
        <div style={{ position: "relative", marginBottom: 20 }}>
          <div
            style={{
              position: "relative",
              height: 152,
              width: 152,
              borderRadius: "50%",
              overflow: "hidden",
            }}
          >
            {/* Progress ring */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                background: `conic-gradient(var(--Primary-500) ${progressDeg}deg, #2A4051 0deg)`,
                WebkitMask:
                  "radial-gradient(farthest-side, transparent calc(100% - 8px), #000 0)",
                mask: "radial-gradient(farthest-side, transparent calc(100% - 8px), #000 0)",
              }}
            />

            {/* Avatar */}
            <div
              style={{
                position: "absolute",
                inset: 8,
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              <img
                src={user?.image}
                alt={user?.full_name}
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>

          {/* Level badge */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              height: 48,
              width: 48,
              borderRadius: "50%",
              backgroundColor: "var(--Primary-500)",
              color: "#fff",
              fontWeight: 700,
              fontSize: 15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid #1C2A37",
            }}
          >
            {user?.user_level}
          </div>
        </div>

        {/* Name */}
        <h2
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: "#E6ECF1",
            marginBottom: 6,
          }}
        >
          {user?.full_name}
        </h2>

        {/* Level text */}
        <p
          style={{
            fontSize: 15,
            color: "#B5BBC0",
            marginBottom: 18,
          }}
        >
          Level {user?.user_level}
        </p>

        {/* Points */}
        <div
          className="d-flex align-items-center"
          style={{ gap: 6, fontSize: 15 }}
        >
          <span
            style={{
              color: "var(--Primary-500)",
              fontWeight: 600,
            }}
          >
            {level?.remaining_points} points
          </span>
          <span style={{ color: "#B5BBC0" }}>to level up</span>
          <img
            src="/icons/help-circle.svg"
            alt="help-circle"
            style={{
              marginLeft: 4,
              cursor: "pointer",
            }}
            onClick={() =>
              navigate("/leaderboards-info", {
                state: { levelDetails: leaderboardData.levelDetails },
              })
            }
          />
        </div>
      </div>
    </div>
  );
}
